<template>
  <v-menu bottom left>
    <template v-slot:activator="{ on, attrs }">
      <v-chip class="ma-2" color="success" outlined v-bind="attrs" v-on="on">
        Marca
      </v-chip>
    </template>
    <v-card>
      <producto-filtro-marca
        type="list"
        @select-marca="setMarca"
      ></producto-filtro-marca>
    </v-card>
  </v-menu>

  <!-- Otros filtros de plataforma, proveedor, etc. (igual que antes) -->
</template>
  
  <script>
import ProductoFiltroMarca from "@/components/producto/filtros/producto.filtro.marca.vue";


export default {
  components: {
    ProductoFiltroMarca,
  },
  data() {
    return {
      selectedMarca: null,
    };
  },
  //   watch: {
  //     // Watcher para escuchar cambios en la URL y actualizar la categoría seleccionada
  //     "$route.query": function (newCategoria) {
  //         console.log(newCategoria);
  //         if (newCategoria.categoria) {
  //             this.selectedMarca = newCategoria.categoria
  //         }

  //       this.selectedMarca = null;
  //     },
  //   },
  watch: {
    "$route.query.marca": {
      handler: function (newCategoria) {
        this.selectedMarca = newCategoria;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // Actualizar la query cuando se cambia la categoría
    setMarca(value) {
      console.log(value);

      this.selectedMarca = value.nombre;
      this.updateQuery("marca", value.nombre);
    },

    // Actualizar la query
    updateQuery(key, value) {
      const query = { ...this.$route.query, [key]: value };
      console.log(query);
      this.$router.replace({ query });
    },

    // Remover el filtro de la query
    removeCategoria() {
      this.selectedMarca = null;
      this.removeQuery("marca");
    },

    // Remover el filtro de la query
    removeQuery(key) {
      const query = { ...this.$route.query };
      delete query[key];
      this.$router.replace({ query });
    },
  },
};
</script>
  
  <style scoped>
/* Estilos para los filtros, puedes adaptarlos como necesites */
</style>
  